module.exports = __webpack_public_path__ + "img/search.75912399.svg";